module.exports = __webpack_public_path__ + "static/media/ios_tips_04.25485edc.png";